import React from "react";
import Timeline from "pages/content/components/Timeline";
import Markdown from "markdown-to-jsx";

const formatDate = (date) => new Date(date).toLocaleDateString("en-US", { year: "numeric", month: "long" });
let align = 0;
const getAlign = () => (++align % 2 === 0 ? "left" : "right");
const cta = (cta) => {
  if (!cta || cta.length === 0) {
    return { label: "", url: "" };
  }
  return { label: cta[0].label, url: cta[0].url.cached_url };
};

const buildTimelineConfigFromItem = (item) => {
  if (item.component === "timeline_event") {
    const date = formatDate(item.date);
    return {
      timelineType: "event",
      align: "",
      date,
      heading: "",
      type: item.type,
      primaryText: item.headline,
      secondaryText: item.description,
      content: "",
      href: "",
      linkText: "",
      image: "",
    };
  }
  if (item.component === "timeline_quote") {
    return {
      timelineType: "quote",
      align: getAlign(),
      date: "",
      heading: "",
      type: "",
      primaryText: item.quote,
      secondaryText: "",
      content: item.attribution,
      href: "",
      linkText: "",
      image: "",
    };
  }

  if (item.component === "timeline_staff") {
    const date = formatDate(item.date);
    return {
      timelineType: "event",
      align: "",
      date,
      heading: "",
      type: "staff",
      primaryText: `+ ${item.name}`,
      secondaryText: item.department,
      content: "",
      href: "",
      linkText: "",
      image: "",
    };
  }

  if (item.component === "timeline_story") {
    const date = formatDate(item.date);
    const button = cta(item?.cta);
    return {
      timelineType: "story",
      align: getAlign(),
      date,
      heading: item.headline,
      type: item.type,
      primaryText: "",
      secondaryText: "",
      content: <Markdown>{item.content}</Markdown>,
      href: button.url,
      linkText: button.label,
      image: item.image?.filename,
    };
  }
};

const getTimelineItems = (items) => items.map((item) => buildTimelineConfigFromItem(item));
const carousel = ({ items }) => (<Timeline items={getTimelineItems(items)} />);

export default carousel;
